import LegalPage from "@/components/LegalPage";

const SECTIONS = [
  {
    h: "Overview",
    body: [
      "Imaginepedia Technologies (\"we\", \"our\") respects your privacy. This policy explains what personal information we collect through this website, how we use it, and the rights you have over it.",
    ],
  },
  {
    h: "Information we collect",
    body: [
      "We collect information you provide directly — such as your name, email address, subject line and message when you submit the contact form. We also collect limited technical data automatically, including IP address, browser type and pages visited, for analytics and security purposes.",
    ],
  },
  {
    h: "How we use information",
    body: [
      "We use the information you provide to respond to your inquiries, deliver requested services, improve the site, and comply with legal obligations. We do not sell personal data.",
    ],
  },
  {
    h: "Legal bases",
    body: [
      "Where applicable law (such as the GDPR or the DPDP Act) requires it, we rely on your consent, our legitimate business interests, or the performance of a contract as our legal basis for processing your data.",
    ],
  },
  {
    h: "Data retention",
    body: [
      "We retain contact submissions and related correspondence for as long as necessary to fulfil the purposes described in this policy, unless a longer retention period is required by law.",
    ],
  },
  {
    h: "Sharing with third parties",
    body: [
      "We share personal information only with trusted service providers who help us operate the site (for example, hosting, email or analytics providers) and only to the extent necessary. These providers are bound by confidentiality obligations.",
    ],
  },
  {
    h: "Your rights",
    body: [
      "You may request access to, correction of, or deletion of your personal information. You may also object to or restrict certain processing. To exercise these rights, email us at hello@imaginepedia.tech.",
    ],
  },
  {
    h: "Cookies",
    body: [
      "This site uses only essential cookies required for basic functionality and, where enabled, privacy-friendly analytics. You can control cookies through your browser settings.",
    ],
  },
  {
    h: "Security",
    body: [
      "We follow industry-standard practices to protect personal information in transit and at rest. No method of transmission over the internet is fully secure, but we work to mitigate risks continuously.",
    ],
  },
  {
    h: "Changes to this policy",
    body: [
      "We may update this policy periodically. The \"Last updated\" date at the top reflects the latest revision.",
    ],
  },
];

export default function Privacy() {
  return (
    <LegalPage
      testId="page-privacy"
      index={2}
      label="Legal"
      title="Privacy Policy."
      updated="10 December 2025"
      sections={SECTIONS}
    />
  );
}
